import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import About from '../components/About'
import Project from '../components/Project'
import Contact from '../components/Contact'
import WhatsAppButton from '../components/WhatsAppButton'
import Footer from '../components/Footer'
import { useContent, useProject } from '../lib/useContent'

import Gallery from '../components/Gallery'

export default function Home() {
  const { content, loading: contentLoading } = useContent()
  const { project, loading: projectLoading } = useProject()

  // We no longer block the entire page for content/project loading.
  // This allows the browser to render the default content immediately, improving LCP and perceived performance.
  // The components handle empty/loading states gracefully (e.g., Hero without image).

  return (
    <div className="min-h-screen w-full text-center overflow-x-hidden">
      <Navbar content={content} />
      <Hero content={content} />
      <About content={content} />
      <Gallery content={content} />
      <Project project={project} />
      <Contact content={content} />
      <Footer />
      <WhatsAppButton number={content.whatsapp_number} number2={content.whatsapp_number_2} name1={content.whatsapp_name} name2={content.whatsapp_name_2} />
    </div>
  )
}
